import { Modal } from "react-bootstrap";

const  PopupModel=({isShow,onHide,children,header,size})=> {
  
    return (
      <>
        <Modal
          show={isShow}
          onHide={onHide}
          size={size}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {header && <Modal.Header closeButton>
            {header}
          </Modal.Header>}
        {children}
        </Modal>
      </>
    );
  }
  
  export default PopupModel;
  